import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    DocumentId,
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import FormSet from '../../types/api/form-set'
import getQuery from '../../helpers/api/get-query'

export const formSetsApi = createApi({
    reducerPath: 'formSetsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['FormSet'],
    endpoints: builder => ({
        getFormSets: builder.query<Strapi<FormSet>, EndpointQueryParameters | void>({
            query: getQuery('/form-sets'),
            providesTags: ['FormSet'],
        }),
        getFormSetByDocId: builder.query<
            StrapiSingle<FormSet>,
            [DocumentId, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/form-sets/${docId}`)(params),
            providesTags: ['FormSet'],
        }),
        createFormSet: builder.mutation<StrapiSingle<FormSet>, StrapiCreate<FormSet>>({
            query: body => ({
                url: '/form-sets',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['FormSet'],
        }),
        updateFormSet: builder.mutation<StrapiSingle<FormSet>, StrapiUpdate<FormSet>>({
            query: ({ docId, body }) => ({
                url: `/form-sets/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['FormSet'],
        }),
    }),
})

export const {
    useGetFormSetsQuery,
    useGetFormSetByDocIdQuery,
    useCreateFormSetMutation,
    useUpdateFormSetMutation,
    useLazyGetFormSetByDocIdQuery,
} = formSetsApi
